export default {
  ResinvoiceHistory: "Invoice History",
  RessearchInvoice: "Search Invoice Number...",
  ResnoInvoices: "No invoices found",
  Resinvoice: "Invoice",
  Resorder: "Order",
  Resdate: "Date",
  Restotal: "Total",
  Resstatus: "Status",
  Resview: "View",
};